import React, { useState } from 'react';
import DashboardSidebar from './DashboardSidebar';
import DashboardHeader from './DashboardHeader';

const DashboardLayout = ({ 
  user, 
  onLogout, 
  children, 
  headerProps,
  onShowLogoutDialog,
  onShowFeedbackModal,
  onUpgradeClick,
  supportTickets = []
}) => {
  const [sidebarOpen, setSidebarOpen] = useState(false);

  return (
    <div className="min-h-screen bg-black flex">
      {/* Sidebar */}
      <DashboardSidebar 
        sidebarOpen={sidebarOpen} 
        setSidebarOpen={setSidebarOpen}
        onShowLogoutDialog={onShowLogoutDialog || (() => {})}
        onShowFeedbackModal={onShowFeedbackModal || (() => {})}
        supportTickets={supportTickets}
      />

      {/* Main content */}
      <div className="flex-1 flex flex-col lg:ml-0">
        {/* Header */}
        <DashboardHeader 
          user={user}
          sidebarOpen={sidebarOpen}
          setSidebarOpen={setSidebarOpen}
          onUpgradeClick={onUpgradeClick}
          {...(headerProps || {})}
        />

        {/* Page content */}
        <main className="flex-1 overflow-auto">
          {children}
        </main>
      </div>
    </div>
  );
};

export default DashboardLayout;
